import React from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { PowerRankingRowData } from './types';

interface CoachingTabProps {
  data: PowerRankingRowData[];
}

export function CoachingTab({ data }: CoachingTabProps) {
  const coachingColumns: MRT_ColumnDef<PowerRankingRowData>[] = [
    {
      accessorKey: 'teamName',
      header: 'Team',
      size: 150,
      enableHiding: false,
    },
    {
      accessorKey: 'totalOptimalPoints',
      header: 'Optimal Points',
      Cell: ({ cell }) => (
        <Box>{Math.round(cell.getValue() as number)}</Box>
      )
    },
    {
      accessorKey: 'totalOptimalPointsRank',
      header: 'Optimal Points Rank',
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number}</Box>
      )
    },
    {
      accessorKey: 'totalPoints',
      header: 'Actual Points',
      Cell: ({ cell }) => (
        <Box>{Math.round(cell.getValue() as number)}</Box>
      )
    },
    {
      accessorKey: 'optimalPointsDiff',
      header: 'Points Left',
      Cell: ({ cell }) => (
        <Box style={{ color: cell.getValue() as number > 0 ? 'red' : 'green' }}>
          {Math.round(cell.getValue() as number)}
        </Box>
      )
    },
    {
      accessorKey: 'optimalPointsDiffPctg',
      header: 'Efficiency %',
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number !== undefined ? (100 - Math.round(cell.getValue() as number * 1000) / 10) + "%" : '-'}</Box>
      ),
    },
    {
      accessorKey: 'coachRank',
      header: 'Coaching Rank',
      Cell: ({ cell }) => (
        <Box><b>#{cell.getValue() as number}</b></Box>
      ),
    },
  ];

  return (
    <MaterialReactTable 
      columns={coachingColumns} 
      data={data} 
      enableColumnActions={false}
      enablePagination={false}
      initialState={{
        sorting: [
          {
            id: 'coachRank',
            desc: false,
          },
        ],
        density: 'compact',
      }}
    />
  );
}
